/// <amd-module name="Artifacts/Nuget/commands/Badge" />
import { getBadgeCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createBadgeCommand = getBadgeCommandCreator();
